import { FC, PropsWithChildren, useState } from 'react';
import layoutData from './../../../layout-data.preval';
import HeaderBanner from '../ui/banners/header-banner/HeaderBanner';
import Meta from '../seo/Meta';
import localFont from 'next/font/local';
import Menu from './menu/Menu';
import StickyBanner from '../ui/banners/sticky-banner/StickyBanner';
import TopBanner from '../ui/banners/top-banner/TopBanner';
import FooterBanner from '../ui/banners/footer-banner/FooterBanner';
import { IMeta } from '../../interfaces/meta.interface';
import { IBookPage } from '@/interfaces/booksPage.interface';
import { IGenresData } from '@/interfaces/genres.interface';
import styles from './Layout.module.scss';
import Footer from './footer/Footer';

const fontArial = localFont({
  src: [
    {
      path: './../../fonts/arial.woff',
      weight: '400',
      style: 'normal',
    },
    {
      path: './../../fonts/arial-bold.woff',
      weight: '700',
      style: 'bold',
    },
  ],
});

interface ILayout extends IMeta {
  menuNew?: IBookPage;
  menuGenres?: IGenresData[];
}

const Layout: FC<PropsWithChildren<ILayout>> = ({ children, title, description, pageHref, canonicalHref, robotsNoFollow, cover, menuNew, menuGenres }) => {
  const prefetchedGenresMenuData = layoutData;
  const [isMobileMenu, setIsMobileMenu] = useState(false);

  return (
    <Meta title={title} description={description} pageHref={pageHref} cover={cover} canonicalHref={canonicalHref} robotsNoFollow={robotsNoFollow}>
      <div className={styles.pageWrapper}>
        <HeaderBanner />

        <main className={styles.mainContainer} style={fontArial.style} menu-data={isMobileMenu ? 'mobile-menu' : 'desktop-menu'}>
          <div className={styles.mainContainer__menu}>
            <Menu isMobileMenu={isMobileMenu} setIsMobileMenu={setIsMobileMenu} menuNew={menuNew ? menuNew : prefetchedGenresMenuData.newBooksMenuData} menuGenres={menuGenres ? menuGenres : prefetchedGenresMenuData.genresMenuData} />
          </div>

          <div className={styles.mainContainer__content}>
            <div className={styles.mainContainer__topBanner}>
              <TopBanner />
            </div>
            <div className={styles.mainContainer__wrap}>{children}</div>
            <Footer />
            <div className={styles.mainContainer__bottomBanner}>
              <FooterBanner />
            </div>
          </div>
          <div className={styles.mobileOverlay} onClick={() => setIsMobileMenu(false)}></div>
        </main>
        <StickyBanner />
      </div>
    </Meta>
  );
};

export default Layout;
